import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { UNBLOCK_WS } from "./actionTypes";
import { unBlockWorkstationsSuccess, unBlockWorkstationsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* unBlockWorkstation({ payload: { ws, token, history } }) {

  try {

    const response = yield call(workstationAPI.unBlockWorkstation, ws, token);
    yield put(unBlockWorkstationsSuccess(response.message));
    history.go()
  } catch (error) {
    yield put(unBlockWorkstationsError(error));
  }
}

export function* watchUnBlockWorkstations() {
  yield takeEvery(UNBLOCK_WS, unBlockWorkstation);
}

function* UnBlockWorkstationsSaga() {
  yield all([fork(watchUnBlockWorkstations)]);
}

export default UnBlockWorkstationsSaga;
